import { updateGlobalLoader } from "../../components/backdrop/backdropSlice";
import { api } from "../../utils/api";
import { endpoints } from "../../utils/endpoints";
import { updateWishlist } from "./wishlistSlice";
import axios from "axios";
import { BASE_URL } from "../../utils/constant";
export const getWishlistById = async (id) => {
    try {
        const response = await axios.get(BASE_URL + endpoints.getWishlistsForUser + `/${id}`, {
            headers: {
                "Authorization": localStorage.getItem("token") || ""
            },
        })
        const result = response?.data?.result?.data;
        return result;
    } catch (error) {
        return error;
    }
}

export const getMyDraftCampaigns = () => {
    return (dispatch) => {
        dispatch(updateGlobalLoader(true));
        api.getApiCall(
            endpoints.myCampaigns,
            `?filter={"status":"DRAFT"}&limit=1000`,
            (respData) => {
                dispatch(updateGlobalLoader(false));
                let res = respData.data;
                dispatch(updateWishlist({ draftCampaigns: res.result.data }));
            },
            (errors) => {
            }
        );
    };
};
export const addInfluncersToCampaignsFromCurrentList = (payload)=>{
return ()=>{
   api.postApiCall(
    endpoints.addInfluncersToCampaignsFromCurrentList,payload,
    ()=>{
    },()=>{
    }
   )
}
}